import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService, ResponseResult } from 'sv-shared';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TramDoYeuToDoService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.thmpEndpoint}/tramdoyeutodo`);
  }

  getsAllByIdTramDo(idTramDo: number) {
    var url = `${this.serviceUri}/getsAllByIdTramDo/${idTramDo}`;
    return this.defaultGet(url);
  }

  getsByIdTramDo(idTramDo: number) {
    var url = `${this.serviceUri}/getsByIdTramDo/${idTramDo}`;
    return this.defaultGet(url);
  }

  updateByIdTramDo(idTramDo: number, arrElements: any[]): Promise<ResponseResult> {
    const apiUrl = `${this.serviceUri}/UpdateByIdTramDo/${idTramDo}`;
    return this._http
      .post<ResponseResult>(apiUrl, arrElements)
      .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
  }

}
